export default [
  {
    name: '王石',
    title: `万科创始人
深潜创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/wangshi.png',
  },

//  {
//    name: '徐梦桃',
//    title: `冬奥冠军
//   `,
//    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/xumengtao.png',
//  },

  {
    name: '范可新',
    title: `冬奥冠军
    `,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/fankexin2.png',
  },

  {
    name: '毛大庆',
    title: `优客工场
共享际创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/maodaqing.png',
  },

  {
    name: '邵婷',
    title: `前中国女篮队长
北师大博士`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/shaoting.png',
  },

  {
    name: '王剑',
    title: `北京冬奥组委
赞助销售处处长`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/wangjian.png',
  },

  {
    name: '黄海晨',
    title: `ENDEAVOR中国
首席执行官`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/huanghaichen.png',
  },

  {
    name: '张宁',
    title: `知乎战略副总裁
社区业务负责人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/zhangning.png',
  },

  {
    name: '张晗',
    title: `万达体育中国公司
副总经理、整合营销总经理`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/zhanghan.png',
  },

  {
    name: '周天一',
    title: `快手体育负责人
    `,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/zhoutianyi.png',
  },

  {
    name: '黄春翔',
    title: `橙狮体育
副总裁`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/huangchunxiang2.png',
  },

  {
    name: '李海波',
    title: `星谷营地主理人
星系营地集团创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/lihaibo.png',
  },
  
  {
    name: '跳跳',
    title: `超级猩猩
联合创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/tiaotiao.png',
  },
  
  {
    name: '梁峰',
    title: `悦跑圈
联合创始人兼CEO`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/liangfeng.png',
  },

  {
    name: '於健',
    title: `智体园
创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/yujian.png',
  },

  {
    name: '祁欣',
    title: `拼渤数科
总经理`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/qixin.png',
  },
  
  {
    name: '张庆',
    title: `关键之道
创始人、CEO`,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/zhangqing.png',
  },

  {
    name: '辛颖',
    title: `凯兴资本
合伙人`,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/xinying.png',
  },

  {
    name: '颜强',
    title: `肆客体育
创始人`,
    avatar: 'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/yanqiang.png',
  },

  {
    name: '刘建宏',
    title: `凯利时科技董事长、CEO
开承体育董事长`,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/liujianhong.png',
  },

  {
    name: '刘语熙',
    title: `著名主持人
   `,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/liuyuxi.png',
  },

  {
    name: '马军',
    title: `脱口秀演员
   `,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/majun.png',
  },

  {
    name: '韩牧',
    title: `懒熊体育
创始人、CEO`,
    avatar:
     'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/hanmu.png',
  },

//  {
//    name: '黎双富',
//    title: `懒熊体育
//联合创始人、总裁`,
//    avatar:
//     'https://imgcdn.lanxiongsports.com/img/jnh2022/guests/lishuangfu.png',
//  },

];
